import { customType } from "drizzle-orm/pg-core";

export const polygon = customType({
	dataType () {
		return "geometry(Polygon, 4326)";
	},
});
   